import {Residence} from './residence';

export class ResidenceResponse {
    items?: Residence[] = [];
}
